export const ARTICLE_HEADER_CLASSROOMS_LOAD_REQUEST = 'ARTICLE_HEADER_CLASSROOMS_LOAD_REQUEST';
export const ARTICLE_HEADER_CLASSROOMS_LOAD_SUCCESS = 'ARTICLE_HEADER_CLASSROOMS_LOAD_SUCCESS';
export const ARTICLE_HEADER_CLASSROOMS_LOAD_FAILURE = 'ARTICLE_HEADER_CLASSROOMS_LOAD_FAILURE';
